__turbopack_context__.v({
  "circle": "AWyCZW_circle",
  "cluster": "AWyCZW_cluster",
  "label": "AWyCZW_label",
});
